'use client';

import type { FC, HTMLAttributes } from 'react';
import {
    SearchBar,
    type SearchBarProps,
    type SuggestionType,
} from '@paypoteam/ui-components';

import { cn } from '@/lib/utils';

import type { ContentTextProps } from '@/components/molecules/ContentText';
import { ContentText } from '@/components/molecules/ContentText';

export type OnSuggestionSelectType = (suggestion: SuggestionType) => void;

export interface SearchBarContentProps extends HTMLAttributes<HTMLDivElement> {
    contentTextConfig: ContentTextProps;
    searchBarConfig: SearchBarProps;
}

const SearchBarContent: FC<SearchBarContentProps> = ({
    contentTextConfig,
    searchBarConfig,
}) => (
    <div className="flex max-w-[22rem] flex-col lg:max-w-[556px]">
        <ContentText
            {...contentTextConfig}
            className={cn(
                'text-center md:text-left',
                contentTextConfig.className,
            )}
        />

        <SearchBar
            {...searchBarConfig}
            className="mt-8 md:mt-10"
        />
    </div>
);

export default SearchBarContent;
